module.exports = __webpack_public_path__ + "8cd60f2e9dab9049cdb509fa7d089d4d.svg";